import { PERMISSIONS } from "../../../../../PermissionsConstants";
import OHNSAOrgCharts from "../NSAOrgChart/OHNSAOrgCharts";
import OHSalesOrgChart from "../SalesOrgChart/OHSalesOrgChart";
import OHSPLCOrgCharts from "../SPLCOrgChart/OHSPLCOrgChart";

export const OfficeHierarchyOrgChartTab = [
  {
    to: "/officesettings/officehierarchy",
    component: OHSalesOrgChart,
    label: "SALES",
    permission:
      PERMISSIONS.permission_carrieragreemnentmgmt_officehierarchy_view,
  },

  {
    to: "/officesettings/officehierarchy/nsa",
    component: OHNSAOrgCharts,
    label: "NSA",
    permission:
      PERMISSIONS.permission_carrieragreemnentmgmt_officehierarchy_view,
  },

  {
    to: "/officesettings/officehierarchy/splc",
    component: OHSPLCOrgCharts,
    label: "SPLC",
    permission:
      PERMISSIONS.permission_carrieragreemnentmgmt_officehierarchy_view,
  },
];
